// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"dea37869","139":"28f396ea","273":"448ef763","512":"9c2595ac","579":"ece546e0","582":"448ef763","807":"28f396ea","995":"8e2ead74"}[chunkId] + ".chunk.css";
};